Jelly.References.Element_Exists = function(Test_Element) {	

	// Verify that the test element exists in the DOM.
	// TODO: There are faster ways, here... http://jsperf.com/closest-vs-contains/4, but they're much uglier, with fake test ids.  
	// TODO But seemingly at least 30x faster.
	// TODO - I think I made the faster version.
	
	var Recursive_Test_Element = Test_Element;
 
 	// Verify recursive parent nodes of test element until reaching document, or return false.
	while (Recursive_Test_Element) {
		
		// If this is the document, return true
		if (Recursive_Test_Element == document)
			return true;

		else { 

			// If this has an ID, shortcut the while loop with the document.getElementByID function
			if (Recursive_Test_Element.id) {

				// If the document has the id, return true
				if (document.getElementById(Recursive_Test_Element.id)) {
		 			return true;
		 		}

		 		// If the document does jnot have the id, the element must not exist
		 		else {
		 			return false;
		 		}
			}

			// If this does not have an ID, continue to the parent node to try the tree way
			else {
				Recursive_Test_Element = Recursive_Test_Element.parentNode;
			}
		}
	}

	return false;
};